import React, {Fragment} from "react"
import NavBar from "../NavBar"
import {connect} from "react-redux"
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import { I18n } from 'react-redux-i18n'
import { withStyles } from '@material-ui/core/styles'
import Icon from '@material-ui/core/Icon'

import {getAppointmentById} from '../../actions/appointmentActions'

const styles = theme => ({
  hr: {
    width: '100%',
    height: '1px',
    border: '0',
    backgroundColor: 'rgba(0,0,0,0.12)'
  },
  icon: {
    height: '100px',
    lineHeight: '94px',
    fontSize: '40px'
  },
  center: {
    textAlign: 'center'
  }
})

class Appointment extends React.Component {
  constructor(props){
    super(props)

    props.dispatch(getAppointmentById(props.match.params.id))
  }

  render() {
    const { classes } = this.props
    const appointment = this.props.appointment.appointment
    console.log(appointment)

    if(!this.props.appointment.fetchedAppointment){
      return(
        <Fragment>
          <NavBar/>
          <div style={{textAlign: 'center'}}>
            <CircularProgress style={{marginTop: '16px'}} />
          </div>
        </Fragment>
      )
    }

    return (
      <div>
        <NavBar/>
        <Grid container justify="center">
          <Grid item container xs={12} md={6} spacing={16}>
            <Grid xs={2} md={1} className={classes.center}>
              <Icon className={classes.icon} style={{color: appointment.kleuren.kleurcode}}>
                {appointment.iconen == null ?
                  'timelapse'
                  :
                  appointment.iconen.icoon
                }
              </Icon>
            </Grid>
            <Grid xs={10} md={11} item>
              <h1>{appointment.onderwerp}</h1>
            </Grid>
            <hr className={classes.hr} />
            <Grid xs={12} item>
              <h3>{I18n.t('editAppointment.description')}</h3>
              <div dangerouslySetInnerHTML={{__html: appointment.beschrijving}} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  appointment: state.appointment
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Appointment))



// WEBPACK FOOTER //
// ./src/js/components/pages/Appointment.js